import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { googleAuthUrl, startGoogleLogin } from '../../utils/googleLogin'
import { isCapacitor } from '../../platform/capacitor'

/** Google's "G" mark in its brand colours. */
export function GoogleMark({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden className={className}>
      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.66l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
    </svg>
  )
}

interface GoogleSignInButtonProps {
  className?: string
  testId?: string
}

/**
 * "Continue with Google" in the Lu Khach button language: white face (Google's own buttons are
 * light), ink border, hard drop shadow. A real link to the OAuth2 flow, so it works even in the
 * prerendered HTML before the app script has loaded; the mobile app signs in natively on /login.
 */
export default function GoogleSignInButton({ className = '', testId = 'google-signin-btn' }: GoogleSignInButtonProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  return (
    <a
      href={googleAuthUrl()}
      rel="nofollow"
      data-testid={testId}
      onClick={e => {
        if (isCapacitor()) {
          e.preventDefault()
          startGoogleLogin(navigate)
        }
      }}
      className={`inline-flex items-center justify-center gap-2.5 px-5 py-2.5 bg-bq-white border-[3px] border-bq-ink rounded-[14px] shadow-[0_5px_0_#1D2B22] font-extrabold text-[16px] text-bq-ink no-underline whitespace-nowrap transition-transform hover:-translate-y-0.5 active:translate-y-1 active:shadow-[0_1px_0_#1D2B22] ${className}`}
    >
      <GoogleMark />
      <span>{t('guest.google')}</span>
    </a>
  )
}
